// extracted by mini-css-extract-plugin
module.exports = {"formBambino--edit":"FormBambino_formBambino--edit__urxL1","field--name":"FormBambino_field--name__RDQQt","rotation":"FormBambino_rotation__My0Aa"};